import { getTasks, addTask, updateTask, deleteTask } from '../lib/supabase/services/taskService';
import type { Task } from '../lib/supabase/types';
import type { TaskStatus, TaskPriority } from '../types/tasks';
import { SESSION_USER_KEY } from '../config';

let currentUserId: string | undefined;

export function setCurrentUserId(userId: string) {
  currentUserId = userId;
}

function getCurrentUserId(): string | undefined {
  if (!currentUserId) {
    const sessionUserAuth = localStorage.getItem(SESSION_USER_KEY);
    if (sessionUserAuth) {
      try {
        const userAuth = JSON.parse(sessionUserAuth);
        currentUserId = userAuth.id;
      } catch (err) {
        console.error('Failed to parse session user auth:', err);
      }
    }
  }
  return currentUserId;
}

function dispatchTasksUpdated() {
  window.dispatchEvent(new CustomEvent('tasksUpdated'));
}

export async function getTasksForChat(chatId: string): Promise<Task[]> {
  const userId = getCurrentUserId();
  if (!userId) {
    console.error('taskManager: currentUserId is missing!');
    return [];
  }
  const tasks = await getTasks(userId);
  return tasks.filter(task => task.chatId === chatId);
}

export async function addTaskToChat(chatId: string, task: Omit<Task, 'id' | 'chatId' | 'createdAt'>): Promise<Task | null> {
  const userId = getCurrentUserId();
  if (!userId) {
    console.error('taskManager: currentUserId is missing!');
    return null;
  }
  const result = await addTask(userId, { ...task, chatId });
  dispatchTasksUpdated();
  return result;
}

export async function updateTaskInChat(chatId: string, taskId: string, updates: Partial<Task>): Promise<Task | null> {
  const userId = getCurrentUserId();
  if (!userId) {
    console.error('taskManager: currentUserId is missing!');
    return null;
  }
  const result = await updateTask(userId, taskId, updates);
  dispatchTasksUpdated();
  return result;
}

export async function deleteTaskFromChat(chatId: string, taskId: string): Promise<boolean> {
  const userId = getCurrentUserId();
  if (!userId) {
    console.error('taskManager: currentUserId is missing!');
    return false;
  }
  const result = await deleteTask(userId, taskId);
  dispatchTasksUpdated();
  return result;
} 